import { getContract } from "../getContract";

/** @deprecated use `getContract` instead */
export const createContract = getContract;
